import { Link, useRouterState } from '@tanstack/react-router'
import { Home, ListTodo, Calendar, User, Flame } from 'lucide-react'
import { cn } from '@/lib/utils'

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Home', icon: Home },
  { to: '/tasks', label: 'Tasks', icon: ListTodo },
  { to: '/calendar', label: 'Calendar', icon: Calendar },
  { to: '/feed', label: 'Feed', icon: Flame },
  { to: '/profile', label: 'Profile', icon: User },
] as const

export function MobileNav_M10_15() {
  const router = useRouterState()
  const currentPath = router.location.pathname

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 lg:hidden">
      <div className="glass border-t border-white/5 backdrop-blur-xl bg-background/80">
        <div className="flex items-center justify-around h-16 max-w-md mx-auto px-2">
          {NAV_ITEMS.map(({ to, label, icon: Icon }) => {
            const active = currentPath.startsWith(to)
            return (
              <Link
                key={to}
                to={to}
                className={cn(
                  'relative flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-all duration-300',
                  active ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
                )}
              >
                {active && (
                  <span className="absolute top-0 left-1/2 -translate-x-1/2 h-0.5 w-8 rounded-full bg-gradient-to-r from-primary to-primary/50" />
                )}
                <Icon className={cn('h-5 w-5 transition-transform duration-300', active && 'scale-110')} />
                <span className={cn('text-[10px] font-medium transition-opacity', active ? 'opacity-100' : 'opacity-70')}>
                  {label}
                </span>
              </Link>
            )
          })}
        </div>
      </div>
    </nav>
  )
}
